var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13932_75295)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FFF2B8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13932_75295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35938,
    y: 9.36011,
    width: 17.28,
    height: 17.28,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13932_75295)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7976 14.5028C10.7977 12.8554 12.1331 11.52 13.7806 11.52H22.2132C23.8608 11.52 25.1952 12.8555 25.1954 14.5026M25.1954 14.5026L25.1969 16.4487C25.197 16.592 25.1401 16.7295 25.0388 16.8308C24.9376 16.9322 24.8002 16.9891 24.6569 16.9891C24.062 16.9891 23.5841 17.467 23.5841 18.0612C23.5841 18.6549 24.0621 19.1333 24.6569 19.1333C24.9551 19.1333 25.1969 19.3751 25.1969 19.6733V21.6173C25.1969 23.2647 23.8622 24.6003 22.2139 24.6003H13.7791C12.1314 24.6003 10.7969 23.2646 10.7969 21.6173V19.6733C10.7969 19.3751 11.0386 19.1333 11.3369 19.1333C11.9307 19.1333 12.409 18.6551 12.409 18.0612C12.409 17.4945 11.9594 17.0518 11.3369 17.0518C11.1936 17.0518 11.0562 16.9949 10.955 16.8935C10.8537 16.7922 10.7968 16.6548 10.7969 16.5116L10.7976 14.5028C10.7976 14.5027 10.7976 14.5029 10.7976 14.5028M11.8776 14.503L11.877 16.0363C12.7896 16.2587 13.489 17.037 13.489 18.0612C13.489 19.065 12.805 19.9062 11.8769 20.1453V21.6173C11.8769 22.6686 12.7283 23.5203 13.7791 23.5203H22.2139C23.2656 23.5203 24.1169 22.6685 24.1169 21.6173V20.1453C23.1882 19.9064 22.5041 19.0652 22.5041 18.0612C22.5041 17.0567 23.1881 16.2161 24.1165 15.9772L24.1154 14.5034C24.1154 13.4521 23.264 12.6 22.2132 12.6H13.7806C12.7295 12.6 11.8776 13.4519 11.8776 14.503ZM10.7976 14.5028L25.1954 14.5026L10.7976 14.5028Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6251 15.4575L19.126 16.4721L20.2478 16.6352C20.8182 16.7198 21.0506 17.4218 20.6346 17.8284L20.6337 17.8293L19.823 18.6181L20.0146 19.734C20.1133 20.31 19.5087 20.7379 19.0002 20.4727L18.9985 20.4719L17.9971 19.9452L16.994 20.4727C16.4854 20.7379 15.8808 20.3103 15.9795 19.7343L16.1712 18.618L15.361 17.8291L15.3603 17.8284C14.9442 17.4218 15.1766 16.7198 15.747 16.6352L15.7485 16.635L16.8681 16.4721L17.3696 15.4564L17.3702 15.4552C17.6265 14.9395 18.3672 14.9336 18.6247 15.4568C18.6249 15.4571 18.625 15.4573 18.6251 15.4575ZM17.7109 17.2047C17.6322 17.364 17.4802 17.4744 17.3044 17.5L16.6664 17.5928L17.1282 18.0425C17.2556 18.1666 17.3138 18.3454 17.2837 18.5208L17.1743 19.1577L17.7457 18.8572C17.9031 18.7744 18.0911 18.7744 18.2484 18.8572L18.8198 19.1577L18.7105 18.5208C18.6803 18.3454 18.7386 18.1664 18.8661 18.0423L19.3281 17.5928L18.6898 17.5C18.5139 17.4744 18.3619 17.364 18.2833 17.2047L17.9971 16.625L17.7109 17.2047Z",
    fill: "#FFCF00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13932_75295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSales);
export default __webpack_public_path__ + "static/media/targetSales.2a7048698236695ba200a96b7a4ad743.svg";
export { ForwardRef as ReactComponent };